import React, {Component} from "react";
import axios from "axios";
import {GET_USER_ORDER_STATUS} from "../../../../configs";
import {Link} from "react-router-dom";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import DelayLink from "../../../helpers/delayLink";

class RunningStatus extends Component {
  state = {
    orders: [],
  };

  componentDidMount() {
    const { user } = this.props;
    const token = user.success ? this.props.user.data.auth_token : null;

    if(user.success){
      axios
          .post(GET_USER_ORDER_STATUS, {
            token,
          })
          .then((response) => {
            console.log(response.data.data);
            this.setState({ orders: response.data.data });
          });
    }

  }

  render() {
    const { user } = this.props;
    const token = user.success ? this.props.user.data.auth_token : null;
    return (
      <React.Fragment>
        {this.props.user.success && this.state.orders.length > 0 ? (
          <div className="order-status-wrapper" style={{marginTop: "-8px"}}>
            <OwlCarousel
              className="owl-theme"
              loop={false}
              margin={15}
              dots={false}
              lazyLoad={true}
              items={ 1}
              style={{
                margin: "10px 0px",
              }}
            >
              {this.state.orders.map((ord, key) => {
                if (ord.order_status_id === 1) {
                  return (
                    <Link to={"/running-order/" + ord.order.unique_order_id} key={ord.order.id}>
                      <div className="order-status">
                        <div className="icon">
                          <img
                            src="/assets/img/order-placed.gif"
                            className="status-icon"
                          />
                        </div>
                        <div className="status-container">
                          <p>Your order has been received </p>
                          <h6>
                            Your order has been received by the store. The store is looking onto it.
                          </h6>
                        </div>
                      </div>
                    </Link>
                  );
                } else if (ord.order_status_id === 2) {
                  return (
                    <Link to={"/running-order/" + ord.order.unique_order_id} key={ord.order.id}>
                      <div className="order-status">
                        <div className="icon">
                          <img
                            src="/assets/img/various/Group 186.png"
                            className="status-icon"
                          />
                        </div>
                        <div className="status-container">
                          <p>Order is been prepared </p>
                          <h6>
                            Your order was received by the store. Store is now preparing our order
                          </h6>
                        </div>
                      </div>
                    </Link>
                  );
                } else if (ord.order_status_id === 3) {
                  return (
                    <Link to={"/running-order/" + ord.order.unique_order_id} key={ord.order.id}>
                      <div className="order-status">
                        <div className="icon">
                          <img
                            src="/assets/img/various/Group 187.png"
                            className="status-icon"
                          />
                        </div>
                        <div className="status-container">
                          <p>Awaiting pickup </p>
                          <h6>
                            Delivery partner has been assigned. Your order will be picked up shortly
                          </h6>
                        </div>
                      </div>
                    </Link>
                  );
                } else if (ord.order_status_id === 4) {
                  return (
                    <Link to={"/running-order/" + ord.order.unique_order_id} key={ord.order.id}>
                      <div className="order-status">
                        <div className="icon">
                          <img
                            src="/assets/img/various/Group 188.png"
                            className="status-icon"
                          />
                        </div>
                        <div className="status-container">
                          <p>Enroute your way! </p>
                          <h6>
                            Our delivery partner is on the way to deliver your order. He might call if needed
                          </h6>
                        </div>
                      </div>
                    </Link>
                  );
                } else if (ord.order_status_id === 5) {
                  return (
                    <Link to={"/running-order/" + ord.order.unique_order_id} key={ord.order.id}>
                      <div className="order-status">
                        <div className="icon">
                          <img
                            src="/assets/img/various/delivered.png"
                            className="status-icon"
                          />
                        </div>
                        <div className="status-container">
                          <p>Order delivered </p>
                          <h6>
                            You order has been delivered to you successfully.
                          </h6>
                        </div>
                      </div>
                    </Link>
                  );
                } else {
                  return (<DelayLink to={"/running-order/" + ord.order.unique_order_id} key={ord.order.id}>
                    <div className="order-status">
                      <div className="icon">
                        <img
                            src="/assets/img/order-placed.gif"
                            className="status-icon"
                        />
                      </div>
                      <div className="status-container">
                        <p>You have an ongoing order</p>
                        <h6>
                          Tap to here to view the status of your order.
                        </h6>
                      </div>
                    </div>
                  </DelayLink>)
                }
              })}
            </OwlCarousel>
          </div>
        ) : (
          // <div className="order-status-none">
          //  You have no order right now !!!
          // </div>
          ""
        )}
      </React.Fragment>
    );
  }
}

export default RunningStatus;
